import React from "react";
import styles from "./style.module.css";
import Main from "../../../Components/Layouts/Main";
import Brokers from "../../../Components/Layouts/Brokers";
import Forex from "../../../Components/Layouts/Forex";

const Home = () => {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <Main />
          <Brokers />
          <Forex />
        </div>
      </div>
    </>
  );
};

export default Home;
